import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmAdsEltvDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'mwmAdsEltvd30Avg',
      field: 'mwm_total_ads_pred_d30_360_eur',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmAdsEltvd10Avg',
      field: 'mwm_total_ads_pred_d10_360_eur',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmAdsEltvd7Avg',
      field: 'mwm_total_ads_pred_d7_360_eur',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmAdsEltvd3Avg',
      field: 'mwm_total_ads_pred_d3_360_eur',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmAdsEltvd0Avg',
      field: 'mwm_total_ads_pred_d0_360_eur',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM AD eLTV',
}
